import { Box, Typography } from "@mui/material";
import {
    SalesConditionBoxStyled,
    SalesConditionContainerStyled,
    SalesConditionLabelStyled,
    SalesConditionValueStyled,
    useClasses,
   
} from "./SaleCondition.style";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useFormClasses } from "./CreateOfferOrderForm.style";
import { SalesConditionsDTO } from "../../../../explorer/types/OrderOffer/SalesConditions";
import SkeletonList from "../../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";

type SalesConditionProps = {
    open: boolean;
    salesConditions: SalesConditionsDTO | null;
};



export const SalesCondition: React.FC<SalesConditionProps> = ({
    open,
    salesConditions,
}) => {
    const { t } = useTranslation();
    const classesForm = useFormClasses();
    const classes = useClasses();
    return open ? (
        salesConditions !== null ? (
            <SalesConditionContainerStyled>
                <Typography sx={classesForm.title}>
                    {t("common.salesCondition")}
                </Typography>

                <SalesConditionBoxStyled>
                    <SalesConditionLabelStyled>
                        {t("orderoffer.carrier")}
                    </SalesConditionLabelStyled>
                    <SalesConditionValueStyled>
                        {salesConditions.carrier}
                    </SalesConditionValueStyled>
                </SalesConditionBoxStyled>

                <SalesConditionBoxStyled>
                    <SalesConditionLabelStyled>
                        {t("orderoffer.delivery_terms")}
                    </SalesConditionLabelStyled>
                    <SalesConditionValueStyled>
                        {salesConditions.deliveryTerms}
                    </SalesConditionValueStyled>
                </SalesConditionBoxStyled>

                <SalesConditionBoxStyled>
                    <SalesConditionLabelStyled>
                        {t("orderoffer.payment_terms")}
                    </SalesConditionLabelStyled>
                    <SalesConditionValueStyled>
                        {salesConditions.paymentTerms}
                    </SalesConditionValueStyled>
                </SalesConditionBoxStyled>

                <SalesConditionBoxStyled>
                    <SalesConditionLabelStyled>
                        {t("orderoffer.payment_method")}
                    </SalesConditionLabelStyled>
                    <SalesConditionValueStyled>
                        {salesConditions.paymentMethod}
                    </SalesConditionValueStyled>
                </SalesConditionBoxStyled>

                <SalesConditionBoxStyled>
                    <SalesConditionLabelStyled>
                        {t("orderoffer.currency")}
                    </SalesConditionLabelStyled>
                    <SalesConditionValueStyled>
                        {salesConditions.currency}
                    </SalesConditionValueStyled>
                </SalesConditionBoxStyled>
            </SalesConditionContainerStyled>
        ) : (
            <SkeletonList sx={classes.skeleton}  mkey="SaleCondition" rows={5} cols={1} rowsForCell={1} />
        )
    ) : (
        <></>
    );
};
